import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookCheckboxWrapper } from 'src/components/CookbookCheckboxWrapper/CookbookCheckboxWrapper';

export interface SSOEnableProps {
  name: string;
  id: string;
  disabled: boolean;
}

export function SSOEnableControl({
  name,
  id,
  disabled,
}: SSOEnableProps): JSX.Element {
  const { control } = useFormContext();

  return (
    <CookbookCheckboxWrapper
      control={control}
      id={id}
      name={name}
      label="SSO"
      disabled={disabled}
    />
  );
}
